<!--  -->
<template>
  <div id="main" class="padd60">
    <div ref="top" class="top">
      <img :src="require('@/assets/product/product_top.jpg')">
      <div class="title">
        <div class="titleTop">产品布局</div>
        <div>
          主营产品包括基于GIS的能源网资源管理系统、IOT能源大数据平台、电网数字化与智能应用、增量配电网运营管控一体化应用系统以及综合智慧能源服务平台等,助力电网和综合能源系统等精益化管理,与客户共同打造数字化、智慧化的电网运营和综合能源服务新业态。
        </div>
      </div>
    </div>
    <div ref="tabs" class="nav">
      <div class="nav_list" :class="{ isFixed: isFixed }">
        <ul class="nav_ul">
          <li
            v-for="(item, tabIndex) in tabs"
            :key="tabIndex"
            class="nav_li "
            :class="{ navActive: activeIndex === tabIndex }"
            @click="tabClick(tabIndex, item.ref)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div ref="overview" class="overview">
      <h3>产品概览</h3>
      <div class="product_wrap">
        <ul class="product_list">
          <li v-for="(list, i) in productList" :key="i" class="product_li">
            <div class="li_logo">
              <img :src="list.logo">
            </div>
            <div class="li_title">{{ list.title }}</div>
            <div class="li_describe">
              {{ list.describe }}
            </div>
            <div class="li_link">
              <!--
              查看详情 <img :src="require('@/assets/product/right.svg')">
              -->
            </div>
          </li>
        </ul>

        <ul class="product_list product_list2">
          <li
            v-for="(list, listIndex) in productList2"
            :key="listIndex"
            class="product_li"
          >
            <div class="li_logo">
              <img :src="list.logo">
            </div>
            <div class="li_title">{{ list.title }}</div>
            <div class="li_describe">
              {{ list.describe }}
            </div>
            <div class="li_link">
              <!--
              查看详情 <img :src="require('@/assets/product/right.svg')">
              -->
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      ref="framework"
      class="framework"
      :style="{
        backgroundImage: 'url(' + require('@/assets/product/frameBg.jpg') + ')'
      }"
    >
      <h3>产品概览</h3>
      <div class="image">
        <img :src="require('@/assets/product/frameworkImg.png')">
      </div>
    </div>
    <div ref="customer" class="customer">
      <h3>我们的客户</h3>
      <div class="wrap">
        <ul class="customer_ul">
          <li class="customer_li">
            <img :src="require('@/assets/product/customer1.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer2.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer3.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer4.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer5.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer6.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer7.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer8.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer9.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer10.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer11.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer12.jpg')">
          </li>
          <li class="customer_li">
            <img :src="require('@/assets/product/customer13.jpg')">
          </li>
        </ul>
      </div>
    </div>
    <div
      ref="innovate"
      class="innovate"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/product/innovateBg.jpg') + ')'
      }"
    >
      <h3>技术创新</h3>
      <div class="wrap">
        <ul class="innovate_ul">
          <li class="innovate_li">
            <span class="number">21年</span>
            <span class="content">产品持续打磨</span>
          </li>
          <li class="innovate_li">
            <span class="number">15年</span>
            <span class="content">多网平台建设经验</span>
          </li>
          <li class="innovate_li">
            <span class="number">1.2亿+</span>
            <span class="content">维护设备总数</span>
          </li>
          <li class="innovate_li">
            <span class="number">200+</span>
            <span class="content">电网数字化与智能化应用</span>
          </li>
          <li class="innovate_li">
            <span class="number">20+</span>
            <span class="content">IoT能源大数据平台及综合智慧能源服务平台</span>
          </li>
          <li class="innovate_li">
            <span class="number">20+</span>
            <span class="content">增量配电网运营管控一体化应用系统</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  components: {},
  data() {
    return {
      initListArr: [], // 计算滚动高亮高度
      activeName: 'overview',
      index: 0,
      isFixed: false, // 是否fixed
      tabs: [
        { name: '产品概览', ref: 'overview' },
        { name: '产品架构', ref: 'framework' },
        { name: '我们的客户', ref: 'customer' },
        { name: '创新发展', ref: 'innovate' }
      ],
      productList: [
        {
          title: '增量配电网运营管控一体化应用系统',
          logo: require('@/assets/product/productLogo1.svg'),
          describe:
            '支撑配电网设备资产管理、生产运检、调度管理、营销服务以及综合能源增值服务等全业务的开展，提升配电网的投资效率、能源效率和管理效率。'
        },
        {
          title: '电网数字化与智能化应用',
          logo: require('@/assets/product/productLogo2.svg'),
          describe:
            '涵盖发、输、变、配、用能全流程，覆盖规划、采购、运行、检修供应链全环节，支撑调度运行、经营管理等全业务域的统一数字电网模型。'
        },
        {
          title: '综合智慧能源服务平台',
          logo: require('@/assets/product/productLogo3.svg'),
          describe:
            '为单个、多个、区域和跨区等多样化的客户，提供安全、经济、清洁、高效、开放、共享特征的综合智慧能源服务系统。'
        }
      ],
      productList2: [
        {
          title: '基于GIS的能源网资源管理系统',
          logo: require('@/assets/product/productLogo4.svg'),
          describe:
            '具有强大的能源网构建、时空数据管理、能源查询和分析、多维数据融合和可视化演示、业务集成应用支撑以及面向桌面、大屏、WEB、移动多端应用开发的全面支持能力。'
        },
        {
          title: '电网数字化与智能化应用',
          logo: require('@/assets/product/productLogo5.svg'),
          describe:
            '基于“物”模型的物联设备管理。利用“产品-服务”的物模型定义和管理，实现快速、批量管理大量采集装置，并实现远程配置与升级等。'
        }
      ],
      activeIndex: 0
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getHeight()
    })

    this.tabsHeight = this.$refs.tabs.offsetHeight
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    /** 滚动事件 */
    handleScroll() {
      this.getHeight()
      this.isScroll = true
      // 获取页面滚动条的高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.scrollTop = scrollTop
      const offsetTop = this.getOffsetTop(this.$refs.tabs)
      this.isFixed = scrollTop > offsetTop // 是否固定
      if (!this.isScroll) return
      // 滚动高亮
      const [block1, block2, block3, block4] = this.initListArr
      if (scrollTop < block1) {
        this.activeIndex = ''
      } else if (block1 <= scrollTop && scrollTop < block2) {
        this.activeIndex = 0
      } else if (block2 < scrollTop && scrollTop < block3) {
        this.activeIndex = 1
      } else if (block3 < scrollTop && scrollTop < block4) {
        this.activeIndex = 2
      } else if (scrollTop > block4) {
        this.activeIndex = 3
      }
    },
    getOffsetTop(obj) {
      let offsetTop = 0
      while (obj != window.document.body && obj != null) {
        offsetTop += obj.offsetTop
        obj = obj.offsetParent
      }
      return offsetTop
    },
    getHeight() {
      let initTop = this.$refs.overview.offsetTop - 20
      this.initListArr = []
      this.tabs.forEach(item => {
        const elem = this.$refs[item.ref]
        const blockHeight = parseInt(
          window.getComputedStyle(elem, null)['height']
        )
        this.initListArr.push(initTop)
        initTop = initTop + blockHeight - 30 // 偏移距离30
      })
    },
    tabClick(index, ref) {
      // 点击高亮滚动
      // 获取当前选中的index以便后面滚动高亮
      this.activeIndex = parseInt(index)
      this.activeName = ref
      // 给定一个标识，锚点事件不触发滚动
      this.isScroll = false
      this.isChange = false
      // 获取当前选中元素的top值（给元素绑定对应的ref值）
      const offsetTop = this.getOffsetTop(this.$refs[ref])
      const scrollTop = offsetTop - this.$refs['tabs'].offsetHeight
      // 获取当前位置方法
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop
      this.scrollAnimation(currentY, scrollTop)
    },
    // 滚动
    scrollAnimation(currentY, targetY) {
      this.isScroll = true
      // 计算需要移动的距离
      const needScrollTop = targetY - currentY
      let _currentY = currentY
      setTimeout(() => {
        const dist = Math.ceil(needScrollTop / 10)
        _currentY += dist
        window.scrollTo(_currentY, currentY)
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY)
        } else {
          this.isScroll = false
          window.scrollTo(_currentY, targetY)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.top {
  width: 100%;
  position: relative;
  font-size: 13px;
  > img {
    width: 100%;
    height: 100%;
  }
  .title {
    position: absolute;
    top: 30%;
    width: 40%;
    transform: translate(35%, 0);
    .titleTop {
      height: 40px;
      line-height: 40px;
      font-weight: 500;
      color: #fff;
     font-size: 0.48rem;
      margin-bottom: 5px;
    }
    > div {
      line-height: 25px;
      color: #d8d9da;
    }
  }
}
.nav {
  .isFixed {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    background: #f5f5f9;
  }
  width: 100%;
  background: #f5f5f9;
  height: 40px;
  display: flex;
  align-items: center;
  .nav_list {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    .nav_ul {
      display: flex;
      font-size: 0.14rem;
      .nav_li {
        height: 40px;
        line-height: 40px;
        margin-right: 10px;
        cursor: pointer;
        padding: 0 8px;
        &.navActive {
          color: #f1bd1c;
          border-bottom: 2px solid #f1bd1c;
        }
      }
    }
  }
}
.overview {
  background: #fff;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .product_wrap {
    width: 80%;
    margin: 0 auto;
    font-family: 'PingFangSC-Medium';
    .product_list {
      &.product_list2 {
      }
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .product_li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid #dedede;
        border-radius: 4px;
        margin-right: 3%;
        .li_logo {
          margin: 20px 0;
          text-align: center;
          > img {
            width: 38px;
          }
        }
        .li_title {
          margin: 15px 8px;
          color: #261e1c;
          font-size: 16px;
          font-weight: bold;
        }
        .li_describe {
          margin: 10px 12px;
          font-size: 14px;
          color: #261e1c;
        }
        .li_link {
          margin: 20px 0;
          display: flex;
          color: #f1bd1c;
          align-items: center;
          cursor: pointer;
          > img {
            margin-left: 5px;
            width: 20px;
          }
        }
      }
    }
  }
}
.framework {
  background-size: cover;
  > h3 {
    color: #fff;
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .image {
    width: 80%;
    margin: 20px auto 0;
    padding-bottom: 30px;
    text-align: center;
    > img {
      width: 100%;
    }
  }
}

.customer {
  background: #f8f8f9;
  overflow: hidden;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .wrap {
    width: 80%;
    margin: 20px auto;
    .customer_ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .customer_li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        margin: 0 5px 15px 15px;
        > img {
          width: 180px;
        }
      }
    }
  }
}

.innovate {
  background: #fff;
  background-size: bottom 20%;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .wrap {
    width: 80%;
    margin: 0 auto;
    .innovate_ul {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: wrap;
      .innovate_li {
        width: 33.3%;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        .number {
          color: #fcb01e;
          font-size: 22px;
          font-weight: bold;
          letter-spacing: 1px;
          margin-bottom: 5px;
        }
        .content {
          color: #261e1c;
          font-size: 14px;
        }
      }
    }
  }
}

.list {
  margin-top: 10px;
  .list-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    > span {
      font-size: 22px;
      font-weight: bold;
    }
    .line {
      margin-top: 10px;
      height: 3px;
      width: 60px;
      background: #f1bd1c;
    }
    .message {
      width: 80%;
      margin: 20px;
      font-size: 14px;
      text-align: center;
    }
  }
}
.swiper-content {
  width: 99%;
  margin: 50px auto;
  min-height: 500px;
  .swiper-container {
    position: relative;
    width: 100%;
    height: 100%;
    .swiper-slide {
      cursor: pointer;
      .list-logo {
        text-align: center;
        > img {
          width: 100%;
        }
      }
      .list-title {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        height: 55px;
        line-height: 55px;
        color: #333;
        text-align: center;
      }
      .list-describe {
        width: 100%;
        line-height: 25px;
        color: #777570;
        max-height: 230px;
        overflow: auto;
        font-size: 13px;
      }
      .list-productname {
        margin-top: 15px;
        display: flex;
        > span {
          width: 80px;
          color: #777570;
          font-size: 13px;
        }
        > label {
          margin-left: 3px;
          flex: 1;
          font-size: 13px;
        }
      }
      .list-customer {
        margin-top: 15px;
        display: flex;
        align-items: center;
        > span {
          width: 80px;
          color: #777570;
          font-size: 13px;
        }
        > img {
          margin-left: 3px;
          width: 80px;
        }
      }
    }
  }
}
@media screen and (max-width: 639px) {
  #main {
    .top {
      .title {
        width: 90%;
        top: 23%;
        transform: translate(5%, 0);
        > h3 {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
        }
        > div {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
